import React, { Component } from 'react';
import { connect } from 'react-redux';
import Form from 'components/react-validation/components/form';
import Input from 'components/react-validation/components/input';
import * as Vali from 'helper/validator-helper';
import { formatTimezoneDateTime } from 'helper/unit-helper';
import { AppSettings } from '../../constants';
import PropTypes from 'prop-types';
import Submit from '../../components/react-validation/components/submit';
import Datetime from 'react-datetime';
import TableList from 'components/TableList';
import { MessengerBox } from 'components/messenger-box/messenger-box';
import { ContextMenu } from 'components/context-menu/context-menu';
import PubSub from 'services/pubsub-service';
import * as PubSubActionType from 'services/constants';
import * as ProjectActionType from '../constants';
import { EditPhase } from '../Components/phase-edit';
import '../phase.css';
import Moment from 'moment';
import Translate from 'components/translate';

const defaultParams = {
  defaultSortName: 'name',
  defaultSortOrder: 'ascending',
  sizePerPage: 10
};

class ProjectAddEditPhase extends Component {
  static propTypes = {
    match: PropTypes.object,
    ManagePhases: PropTypes.object,
    history: PropTypes.object,
    PhaseProfile: PropTypes.object,
    dispatch: PropTypes.func,
    ErrorMsg: PropTypes.array,
    IsOpenFormEdit: PropTypes.bool,
    projectId: PropTypes.string
  }
  constructor(props) {
    super(props);
    this.state = {
      defaultSortName: props.ManagePhases.params.sort.field, // default sort column name
      defaultSortOrder: props.ManagePhases.params.sort.order, // default sort order,
      currentPage: props.ManagePhases.params.skip,
      sizePerPage: props.ManagePhases.params.take,
      totalRecord: props.ManagePhases.params.totalRecord,
      projectName: '',
      startDate: null,
      isOpenFormEdit: false,
      phaseProfile: {
        id: '',
        name: '',
        projectId: '',
        startDate: null
      },
      dateError: null
    };

    this.projectId = this.props.match.params.projectId ? this.props.match.params.projectId.replace('&', '') : this.props.projectId;

    this.isNew = this.props.match.params.isNew === 'true';

    var me = this;

    PubSub.subscribe(PubSubActionType.PUBLISH_PROJECT_INFORMATION, (msg, data) => {
      me.setState({ projectName: data.project.name });
    });
  }

  componentDidMount() {
    this.binding(this.objToParams(this.props.ManagePhases.params));
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.ErrorMsg.length > 0 && !nextProps.IsOpenFormEdit) {
      const error = nextProps.ErrorMsg[0].error || nextProps.ErrorMsg[0];
      if (this.form) {
        this.form.showError(this.refs['name'], error);
      }

    } else {
      if (this.form) {
        this.form.resetForm(this.refs);
      }
      // this.startdate.reset();
    }

    if (nextProps.ManagePhases) {
      this.setState({
        totalRecord: nextProps.ManagePhases.params.totalRecord,
        currentPage: nextProps.ManagePhases.params.skip
      });
    }
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: ProjectActionType.RESET_PHASE,
      params: null
    });

    // this.props.dispatch({
    //   type: ProjectActionType.RESET_PROJECT,
    //   params: null
    // });
  }

  customeRenderStartDate(item) {
    if (item.startDate) {
      return Moment(item.startDate).format('MM/DD/YYYY');
    }
    return null;
  }

  customRenderBtnAction(item) {
    return <a className='glyphicon glyphicon-option-vertical cls-table-black-icon' onClick={(e) => { this.onContextMenu(e, item); }} />;
  }

  customRenderLots(item) {
    return <span>{item.countLots}</span>;
  }

  customRenderIsActive(item) {

    if (item.status) { return <span>Active</span>; }

    else { return <span>InActive</span>; }

  }

  binding(params) {

    this.props.dispatch({
      type: ProjectActionType.SEARCH_PHASE_ASYNC,
      params: params
    });
  }

  objToParams(obj) {
    return {
      searchKey: '',
      projectId: this.projectId,
      sortField: obj.sort.field,
      sortOrder: obj.sort.order,
      skip: obj.skip - 1,
      take: obj.take
    };
  }

  onContextMenu(e, item) {
    var contextItem = [
      {
        title: <span>Edit <Translate translateKey='phase' capitalize /></span>,
        icon: 'glyphicon glyphicon-pencil',
        event: this.onOpenEditPhase.bind(this)
      }
    ];

    this.cxtMenu.state.event(e, item, contextItem);
  }

  onOpenEditPhase(e, item) {
    this.props.dispatch({
      type: ProjectActionType.GET_PHASE_BY_ID_ASYNC,
      params: item.id,
      callback: () => {
        this.setState({ isOpenFormEdit: true });
      }
    });
  }

  refreshList(params) {
    this.setState({
      defaultSortName: params.defaultSortName,
      defaultSortOrder: params.defaultSortOrder,
      sizePerPage: params.sizePerPage
    }, () => {
      this.props.dispatch({
        type: ProjectActionType.SEARCH_PHASE_ASYNC,
        params: {
          searchKey: '',
          projectId: this.projectId,
          sortField: params.defaultSortName,
          sortOrder: params.defaultSortOrder,
          skip: params.currentPage - 1,
          take: params.sizePerPage
        }
      });
    }
    );
  }

  onCloseEditPhaseModal = () => {
    this.setState({ isOpenFormEdit: !this.state.isOpenFormEdit});
  }

  onSave(e, data, phaseActionType, isEdit) {
    this.props.dispatch({
      type: phaseActionType,
      params: {
        data: data,
        search: this.objToParams(this.props.ManagePhases.params),
        isEdit: isEdit
      },
      callback: this.onCloseEditPhaseModal
    });
  }

  onSubmit(e) {
    e.preventDefault();
    let values = this.form.getValues();
    this.form.validateAll();
    if (!values.name) {
      return;
    }
    if (this.state.startDate) {
      values['startDate'] = Moment.isMoment(this.state.startDate)
        ? formatTimezoneDateTime(this.state.startDate)
        : formatTimezoneDateTime(Moment(this.state.startDate));
    } else {
      values['startDate'] = null;
    }

    this.onSave(e, values, ProjectActionType.CREATE_PHASE_ASYNC, false);
    this.setState({startDate: null});
    // if (this.form) {
    //   this.form.resetForm(this.refs);
    // }
  }

  renderTablePhases() {
    const column = [
      { field: 'id', header: 'id', hidden: true, isKey: true, sort: false, dataAlign: 'left', headerAlign: 'left' },
      { field: 'name', header: 'Name', hidden: false, isKey: false, sort: true, dataAlign: 'left', headerAlign: 'left' },
      { field: 'startDate', header: 'Start date', hidden: false, isKey: false, sort: true, dataAlign: 'left', headerAlign: 'left',
        customRender: this.customeRenderStartDate.bind(this) },
      { field: 'countLots', header: <Translate translateKey='lot' capitalize />, hidden: false, isKey: false, sort: true, dataAlign: 'left', headerAlign: 'left',
        customRender: this.customRenderLots.bind(this) },
      { field: 'status', header: 'Status', hidden: false, isKey: false, sort: true, dataAlign: 'left', headerAlign: 'left',
        customRender: this.customRenderIsActive.bind(this) },
      { field: '', header: '', hidden: false, isKey: false, sort: true, dataAlign: 'right', headerAlign: 'right',
        customRender: this.customRenderBtnAction.bind(this), className: 'column-action', columnClassName: 'column-action' }
    ];

    const options = {
      defaultSortName: this.state.defaultSortName, // default sort column name
      defaultSortOrder: this.state.defaultSortOrder, // default sort order,
      sizePerPage: this.state.sizePerPage,
      totalRecord: this.state.totalRecord,
      hideSizePerPage: true
    };

    return <div>
      <TableList
        column={column}
        defaultParams={defaultParams}
        data={this.props.ManagePhases.items}
        options={options}
        refreshPageList={this.refreshList.bind(this)}
        refreshList={this.refreshList.bind(this)}
      />
    </div>;
  }

  render() {
    let values = {}; // eslint-disable-line
    if (this.form) {
      values = this.form.getValues();
    }
    return <div>
      <div className='alert alert-info' style={{ margin: '0 auto', maxWidth: '640px' }}><strong>Important note:</strong> If you are about to import <Translate translateKey='lot' plurals /> using spreadsheet, you can ignore adding <Translate translateKey='phase' plurals /> since all data (<Translate translateKey='phase' plurals />, plans) will be imported along with lots.</div>
      <br />
      <div className='block' style={{ 'margin': '0 auto', 'maxWidth': '640px' }}>
        <div className='tab-content'>
          <Form ref={c => { this.form = c; }} onSubmit={this.onSubmit.bind(this)}>
            <Input type='hidden' name='projectId' ref='projectId' value={this.projectId} />
            <div className='form-group row'>
              <div className='col-md-6'>
                <div className='form-group'>
                  <label><Translate translateKey='phase' capitalize /> name <span className='text-danger'>*</span></label>
                  <Input type='text'
                    name='name'
                    ref='name'
                    placeholder='Phase name'
                    className='form-control'
                    max='200'
                    maxLength='200'
                    validations={[Vali.required, Vali.maxlength]} />
                </div>
              </div>
              <div className='col-md-4'>
                <div className='form-group'>
                  <label>Start date</label>
                  <Datetime
                    ref={ref => { this.startdate = ref; }}
                    timeFormat={false}
                    value={this.state.startDate}
                    onChange={(selectedDate) => {
                      if (typeof (selectedDate) === 'string') {
                        this.setState({ startDate: selectedDate });
                        if (Moment(selectedDate, 'MM/DD/YYYY', true).isValid() || selectedDate === '') {
                          this.setState({dateError: null});
                        } else {
                          this.setState({dateError: 'Invalid datetime.'});
                        }
                      } else {
                        this.setState({ startDate: Moment(selectedDate).format('MM/DD/YYYY') });
                        if (Moment(selectedDate, 'MM/DD/YYYY', true).isValid() || selectedDate === '') {
                          this.setState({dateError: null});
                        } else {
                          this.setState({dateError: 'Invalid datetime.'});
                        }
                      }
                    }}
                    inputProps={{ placeholder: 'mm/dd/yyyy' }} 
                    closeOnSelect={true}/>
                  {this.state.dateError && <span className='text-danger' style={{fontSize: 12, marginTop: 5}}>{this.state.dateError}</span>}
                </div>
              </div>
              <div className='col-md-2' style={{ 'marginTop': '30px' }}>
                <div className='form-group'>
                  {/* <Submit className='btn btn-primary center-button btn-submit btn-siteone'>Add</Submit> */}
                  <Submit className='btn btn-primary center-button btn-submit btn-siteone' disabled={this.state.dateError}>Add</Submit>
                </div>
              </div>
            </div>
          </Form>
          <div className='form-group'>
            <h5 style={{ 'marginBottom': '15px' }}><Translate translateKey='phase' plurals capitalize /> ({this.state.totalRecord})</h5>
            {this.renderTablePhases()}
            <ContextMenu ref={(ref) => { this.cxtMenu = ref; }} />
            <MessengerBox ref={(ref) => { this.msgBox = ref; }} title={AppSettings.COMPANY_NAME} />
          </div>

        </div>
      </div>
      {
        this.state.isOpenFormEdit &&
        <EditPhase
          onCloseModal={this.onCloseEditPhaseModal}
          item={this.props.PhaseProfile}
          errorMsg={this.props.ErrorMsg}
          isOpenFormEdit={this.state.isOpenFormEdit}
          onSubmit={this.onSave.bind(this)}
        />
      }

    </div>;
  }
}

const mapStateToProps = (state) => {
  return state.PhaseStore;
};

export default connect(mapStateToProps)(ProjectAddEditPhase);



// WEBPACK FOOTER //
// ./src/Projects/Containers/project-add-edit-phase.js